
const state = {
    updateClassDialog: false, // 控制更新班级信息弹窗
    addClassDialog: false, // 控制添加班级弹窗
    updateClassList: false
};

export default state



// WEBPACK FOOTER //
// ./src/store/state.js